import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const SettingsB2BPartners = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  const loadPartners = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/b2b/partners', { headers });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || 'Kunne ikke hente partnere');
      setPartners(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || 'Kunne ikke hente partnere');
      setPartners([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPartners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Slet denne partner?')) return;
    try {
      const res = await fetch(`/api/b2b/partners/${id}`, { method: 'DELETE', headers });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || 'Kunne ikke slette partner');
      loadPartners();
    } catch (err) {
      setError(err.message || 'Kunne ikke slette partner');
    }
  };

  return (
    <div className="px-2 sm:px-4 md:px-6 py-2 sm:py-4">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">B2B partnere</h1>
          <p className="text-sm text-gray-600 dark:text-gray-300">Administrer leverandører og kontaktinfo.</p>
        </div>
        <Link
          to="/indstillinger/b2b/ny"
          className="bg-falck-blue text-white px-4 py-2 rounded-md hover:bg-blue-700"
        >
          Opret partner
        </Link>
      </div>

      {error && <div className="mb-3 p-3 bg-red-100 text-red-700 rounded">{error}</div>}

      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg shadow">
        {loading ? (
          <div className="p-4 text-gray-500">Indlæser...</div>
        ) : partners.length === 0 ? (
          <div className="p-4 text-gray-500">Ingen partnere endnu.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50 dark:bg-gray-800">
                <tr>
                  <th className="px-3 py-2 text-left">Navn</th>
                  <th className="px-3 py-2 text-left">Kontakt</th>
                  <th className="px-3 py-2 text-left">Email</th>
                  <th className="px-3 py-2 text-left">Metode</th>
                  <th className="px-3 py-2 text-left">Handling</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                {partners.map((partner) => (
                  <tr key={partner.id}>
                    <td className="px-3 py-2 font-medium">{partner.name}</td>
                    <td className="px-3 py-2">{partner.contact_name || '—'}</td>
                    <td className="px-3 py-2">{partner.email || partner.order_email || '—'}</td>
                    <td className="px-3 py-2">{partner.order_method}</td>
                    <td className="px-3 py-2">
                      <div className="flex gap-2">
                        <Link
                          to={`/indstillinger/b2b/${partner.id}`}
                          className="text-falck-blue hover:underline"
                        >
                          Rediger
                        </Link>
                        <button
                          type="button"
                          onClick={() => handleDelete(partner.id)}
                          className="text-red-600 hover:underline"
                        >
                          Slet
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingsB2BPartners;
